export default "__VITE_ASSET__fLpQP3B1__"